import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _TitleEdit;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import defer from 'lodash/defer';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { Flex, TextInput } from '@instructure/quiz-common';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';

// =================================

// once editing is toggled this div
// is rendered & has actions that
// allow for canceling

// =================================

export var TitleEdit = /*#__PURE__*/function (_Component) {
  function TitleEdit(props) {
    var _this2;
    _classCallCheck(this, TitleEdit);
    _this2 = _callSuper(this, TitleEdit, [props]);
    /**
     * @type {React.RefObject<TextInput> | null}
     */
    _defineProperty(_this2, "inputRef", null);
    _defineProperty(_this2, "defer", function (fn) {
      // to enable synchronous testing
      var deferFn = _this2.props.deferMock || defer;
      deferFn(fn);
    });
    _defineProperty(_this2, "setInputRef", function (node) {
      _this2.inputRef.current = node;
    });
    _defineProperty(_this2, "switchOffEditing", function () {
      var fromEnterPressed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this2.ifValidElseError(function () {
        _this2.defer(function () {
          if (fromEnterPressed) {
            _this2.props.saveAndPreview(fromEnterPressed);
          } else {
            // make sure they have actually left the component
            if (document.activeElement !== _this2.cancelButton && document.activeElement !== _this2.input) {
              _this2.props.saveAndPreview();
            }
          }
        });
      });
    });
    _defineProperty(_this2, "handleKeyUp", function (e) {
      if (_this2.enterPressed && e.keyCode === 13) {
        return _this2.switchOffEditing(true);
      }
    });
    _defineProperty(_this2, "handleKeyDown", function (e) {
      if (!e.repeat && e.keyCode === 13) {
        _this2.enterPressed = true;
      }
    });
    _defineProperty(_this2, "handleBlur", function (e) {
      _this2.switchOffEditing(false);
    });
    _this2.inputRef = React.createRef();
    return _this2;
  }
  _inherits(TitleEdit, _Component);
  return _createClass(TitleEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var input = this.inputRef.current;
      if (input) {
        input.focus();

        // Note: Some browsers add extra characters so we need to multiply the length by 2 to ensure
        // the cursor is at the end
        input.setSelectionRange(input.value.length * 2, input.value.length * 2);
      }
    }
  }, {
    key: "ifValidElseError",
    value: function ifValidElseError(cb) {
      if (this.props.isValid) {
        this.props.hideError();
        cb();
      } else {
        this.props.showError();
      }
    }
  }, {
    key: "setRef",
    value: function setRef(key) {
      var _this3 = this;
      return function (node) {
        _this3[key] = node;
      };
    }
  }, {
    key: "normalizedErrors",
    get: function get() {
      var _this$props$errors;
      var hasErrors = this.props.errorsAreShowing && this.props.errors.size > 0;
      if (!hasErrors) {
        return [];
      }
      var errorList = (_this$props$errors = this.props.errors) === null || _this$props$errors === void 0 || (_this$props$errors = _this$props$errors.toArray()) === null || _this$props$errors === void 0 ? void 0 : _this$props$errors.map(function (error) {
        if (typeof error === 'object') {
          return error;
        }
        return {
          text: error,
          type: 'newError'
        };
      });
      return errorList || [];
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Flex, {
        direction: "column",
        justifyItems: "center",
        padding: "medium large",
        "data-automation": "sdk-quiz-title-edit-wrapper"
      }, jsx(Flex.Item, null, jsx(TextInput, {
        inputRef: this.setInputRef,
        renderLabel: jsx(ScreenReaderContent, null, t('Title')),
        placeholder: t('Add a Title...'),
        messages: this.normalizedErrors,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onChange: this.props.onInputChange,
        onBlur: this.handleBlur,
        defaultValue: this.props.value,
        "data-automation": "sdk-quiz-title-edit",
        themeOverride: {
          padding: 0,
          borderColor: 'transparent',
          mediumFontSize: '1.75rem',
          fontWeight: '400'
        }
      })));
    }
  }]);
}(Component);
_TitleEdit = TitleEdit;
_defineProperty(TitleEdit, "displayName", 'TitleEdit');
_defineProperty(TitleEdit, "componentId", "Quizzes".concat(_TitleEdit.displayName));
_defineProperty(TitleEdit, "propTypes", {
  value: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  showError: PropTypes.func.isRequired,
  hideError: PropTypes.func.isRequired,
  errors: ImmutablePropTypes.list.isRequired,
  errorsAreShowing: PropTypes.bool,
  onInputChange: PropTypes.func.isRequired,
  saveAndPreview: PropTypes.func.isRequired,
  deferMock: PropTypes.func,
  styles: PropTypes.object
});
_defineProperty(TitleEdit, "defaultProps", {
  errorsAreShowing: false,
  deferMock: defer
});
export default TitleEdit;